export { default as erc20Abi } from './erc20.abi.json';
export { default as stakingAbi } from './staking.abi.json';
